<dx-autocomplete #ac [placeholder]="placeholder" [value]="value" [searchTimeout]="searchTimeout"
    [minSearchLength]="minSearchLength" (onSelectionChanged)="onSelectionChanged($event)" (onChange)="onChange($event)" (onValueChanged)="onValueChanged($event)"
    [dataSource]="autoCompleteDataSource" valueExpr="display_name" [showClearButton]="true">
</dx-autocomplete>